import type { CatalogPrice } from "./api";

/** "$2.20" per million tokens, with every digit the price has ("$0.275", "$1.375"), never rounded away. */
export function perMillion(n: number): string {
  for (let d = 2; d <= 6; d++) if (Math.abs(Number(n.toFixed(d)) - n) < 1e-9) return `$${n.toFixed(d)}`;
  return `$${n.toPrecision(4)}`;
}

/** "1M", "922K", "8K"; null when the gateway publishes no figure. */
export function tokenWindow(n: number | null): string | null {
  if (n === null) return null;
  if (n >= 1_000_000) return `${+(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `${Math.round(n / 1_000)}K`;
  return String(n);
}

/** "$2.20 in · $11.00 out", and the cache line when the gateway prices it. */
export function priceLines(p: CatalogPrice): { main: string; cache: string | null } {
  const cache = [
    p.cacheRead !== null ? `${perMillion(p.cacheRead)} cache read` : null,
    p.cacheWrite !== null ? `${perMillion(p.cacheWrite)} cache write` : null,
  ].filter(Boolean).join(" · ");
  return { main: `${perMillion(p.input)} in · ${perMillion(p.output)} out`, cache: cache || null };
}

/** LiteLLM's provider ids in the words people know. Unknown ids are shown as they are. */
export function providerLabel(p: string | null): string | null {
  if (!p) return null;
  if (p.startsWith("bedrock")) return "AWS Bedrock";
  if (p.startsWith("azure")) return "Azure OpenAI";
  if (p.startsWith("gemini") || p.startsWith("vertex")) return "Google";
  return p;
}

/** The router's tiers in plain words. Unknown tiers are shown as LiteLLM names them. */
export const TIER_LABEL: Record<string, string> = {
  SIMPLE: "Simple prompts",
  MEDIUM: "Medium prompts",
  COMPLEX: "Complex prompts",
  REASONING: "Reasoning prompts",
};
